type AnyAction = {
  type: string;
  payload: any;
};

export type UseResourceFilters = [ResourceFiltersValues, ResourceFiltersDispatchMethods];

export type ResourceFiltersDispatchMethods = {
  setResourceFilters: (resourceFilters: Filters[]) => void;
  setResources: (resources: Resource[]) => void;
  removeResource: (resource: Resource) => void;
  setResourcesSearchText: (text: string) => void;
  setSelectedFilters: (selectedFilters: ResourceFilter[]) => void;
  removeAllResourceFilters: () => void;
  setPinnedResources: (resources: FavoriteResource[]) => void;
  addPinnedResource: (resource: FavoriteResource) => void;
  removePinnedResource: (resourceId: number) => void;
  setPinActions: (pinAction: string) => void;
};

/** may be different, but these are from prekitt but I think it would be a good idea to know all the filter types */
export type FilterTypes = 'letters' | string;

export type ResourceFilter = {
  id: number;
  value: string;
  componentType: string;
};
/** TODO need to determine what this will look like, it may completely change if it ends up looking like IDTT  */
export type Filters = { name: FilterTypes; values: ResourceFilter[] };
export type FilterGroup = { [filterName: string]: Filters };

export type ResourceFiltersValues = {
  filters: FilterGroup | null;
  activeFilter: Filters | null;
  selectedFilters: ResourceFilter[];
  resources: Resource[];
  resourcesSearchText: string;
  filteredResources: Resource[];
  pinnedResources: FavoriteResource[];
  pinActions: PinActions;
};

export type ResourceState = ResourceFiltersValues;

export enum ResourceActionType {
  SET_FILTERS = 'SET_FILTERS',
  SET_RESOURCES = 'SET_RESOURCES',
  REMOVE_RESOURCE = 'REMOVE_RESOURCE',
  SET_RESOURCES_SEARCH_TEXT = 'SET_RESOURCES_SEARCH_TEXT',
  SET_SELECTED_FILTER = 'SET_SELECTED_FILTER',
  REMOVE_ALL_FILTERS = 'REMOVE_ALL_FILTERS',
  SET_PINNED_RESOURCES = 'SET_PINNED_RESOURCES',
  ADD_PINNED_RESOURCE = 'ADD_PINNED_RESOURCE',
  REMOVE_PINNED_RESOURCE = 'REMOVE_PINNED_RESOURCE',
  SET_PIN_ACTIONS = 'SET_PIN_ACTIONS',
}

export enum ComponentType {
  BUTTON = 'BUTTON',
  CHECKBOX = 'CHECKBOX',
}

export type ResourceAction =
  | {
      type: ResourceActionType.SET_FILTERS;
      payload: Filters;
    }
  | { type: ResourceActionType.SET_RESOURCES; payload: Resource[] }
  | {
      type: ResourceActionType.REMOVE_RESOURCE;
      payload: ResourceFilter[];
    }
  | { type: ResourceActionType.SET_RESOURCES_SEARCH_TEXT; payload: string }
  | {
      type: ResourceActionType.SET_SELECTED_FILTER;
      payload: ResourceFilter[];
    }
  | {
      type: ResourceActionType.REMOVE_ALL_FILTERS;
      payload: null;
    }
  | {
      type: ResourceActionType.SET_PINNED_RESOURCES;
      payload: FavoriteResource;
    }
  | {
      type: ResourceActionType.ADD_PINNED_RESOURCE;
      payload: FavoriteResource[];
    }
  | {
      type: ResourceActionType.REMOVE_PINNED_RESOURCE;
      payload: FavoriteResource[];
    }
  | {
      type: ResourceActionType.SET_PIN_ACTIONS;
      payload: PinActions;
    }
  | AnyAction;

enum AssetType {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  SVG = 'SVG',
  VIDEO = 'VIDEO',
}

enum CharacterCase {
  LOWERCASE = 'LOWERCASE',
  UPPERCASE = 'UPPERCASE',
}

enum CharacterType {
  CURSIVE = 'CURSIVE',
  NUMBER = 'NUMBER',
  PRINT = 'PRINT',
}

type ResourceAsset = {
  captions?: JSON;
  data?: JSON;
  description?: string;
  id: number;
  narrationCaptions?: JSON;
  narrationSrc?: string;
  narrationVtt?: string;
  path: string;
  src: string;
  type: AssetType;
  vtt?: string;
};

type ResourceCharacter = {
  character: string;
  characterCase?: CharacterCase;
  characterType: CharacterType;
  id: number;
};

type ResourceProduct = {
  id: number;
  product: any;
  productId: number;
  resource: any;
  resourceid: number;
};

type ResourceTag = {
  id: number;
  tag: string;
  value: string;
};

type ResourceType = {
  icon: string;
  id: number;
  title: string;
  type: string;
};

export type PinActions = {
  amount: number;
};

export type Resource = {
  asset: ResourceAsset;
  assetId: number;
  characters: ResourceCharacter[];
  data?: JSON;
  description?: string;
  id: number;
  resourceProducts: ResourceProduct[];
  resourceTypeId: number;
  tags: ResourceTag[];
  thumbnail: string;
  title: string;
  type: ResourceType;
  url: string;
  favorite?: FavoriteResource;
};

export type Page = {
  book: any;
  bookId: number;
  characters: ResourceCharacter[];
  id: number;
  pageNumber: number;
  tags: any;
  url: string;
};

export type FavoriteResource = {
  id: number;
  page: Page;
  pageId: number;
  resource: Resource;
  resourceId: number;
  user: any;
  userId: number;
};
